/* tslint:disable */
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ChartDataset, Dataset } from '../../../models/dataset.model';

@Component({
  selector: 'bar-chart',
  templateUrl: './bar-chart.component.html',
  styleUrls: ['./bar-chart.component.css']
})
export class BarChartComponent implements OnInit {

  limit: number;
  step: number;
  min: number;
  max: number;

  barChartOptions = {
    scaleShowVerticalLines: false,
    responsive: true,
    fill: false,
  };
  barChartLegend = true;

  @Input() dataset: Dataset[];
  @Input() label: string;
  @Input() chartData: 'mortality' | 'deathsPerMillion' | 'casesPerMillion';
  @Output() emittedLimit: EventEmitter<number> = new EventEmitter<number>();

  barChartData: ChartDataset[] = [
    { data: [], label: '' }
  ];

  barChartLabels: string[] = [];


  formatLabel(value: number) {
    if (value >= 1000) {
      return Math.round(value / 1000) + 'k';
    }

    return value;
  }

  ngOnInit(): void {
    // Delete MS Zaandam, Western Sahara, Diamond Princess, and Vanuatu countries from dataset
    this.deleteCountries();
    this.setLimits();
    this.loadData();
  }

  private deleteCountries() {
    this.dataset = this.dataset.filter(country => country.country !== 'MS Zaandam' &&
      country.country !== 'Western Sahara' &&
      country.country !== 'Diamond Princess' &&
      country.country !== 'Vanuatu');
  }

  private setLimits() {
    if (this.chartData === 'mortality') {
      this.limit = 1;
      this.step = 0.5;
      this.min = 0;
      this.max = 4;
    }
    if (this.chartData === 'deathsPerMillion') {
      this.limit = 1000;
      this.step = 500;
      this.min = 0;
      this.max = 2000;
    }
    if (this.chartData === 'casesPerMillion') {
      this.limit = 20000;
      this.step = 1000;
      this.min = 0;
      this.max = 20000;
    }
  }

  private loadData() {
    for (let i = 0; i < this.dataset.length; i++) {

      if (this.dataset[i].rate > this.limit) {
        this.barChartData[0].data.push(+(this.dataset[i].rate).toFixed(4));
        this.barChartLabels.push(this.dataset[i].country);
      }
    }
    this.barChartData[0].label = this.label;
  }

  setLimit(event: number) {
    this.limit = event;
    this.barChartData[0].data = [];
    this.barChartLabels = [];
    this.loadData();
    this.emittedLimit.emit(this.limit);
  }
}
